export const fontFaces = `
  @font-face {
    font-family: 'Ideal Sans';
    src: url('/fonts/IdealSans-Thin-Pro.otf') format('opentype');
    font-weight: 100;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Ideal Sans';
    src: url('/fonts/IdealSans-ThinItalic-Pro.otf') format('opentype');
    font-weight: 100;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'Ideal Sans';
    src: url('/fonts/IdealSans-XLight-Pro.otf') format('opentype');
    font-weight: 200;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Ideal Sans';
    src: url('/fonts/IdealSans-XLightItalic-Pro.otf') format('opentype');
    font-weight: 200;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'Ideal Sans';
    src: url('/fonts/IdealSans-Light-Pro.otf') format('opentype');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Ideal Sans';
    src: url('/fonts/IdealSans-LightItalic-Pro.otf') format('opentype');
    font-weight: 300;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'Ideal Sans';
    src: url('/fonts/IdealSans-Book-Pro.otf') format('opentype');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Ideal Sans';
    src: url('/fonts/IdealSans-BookItalic-Pro.otf') format('opentype');
    font-weight: 400;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'Ideal Sans';
    src: url('/fonts/IdealSans-Medium-Pro.otf') format('opentype');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Ideal Sans';
    src: url('/fonts/IdealSans-MediumItalic-Pro.otf') format('opentype');
    font-weight: 500;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'Ideal Sans';
    src: url('/fonts/IdealSans-Semibold-Pro.otf') format('opentype');
    font-weight: 600;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Ideal Sans';
    src: url('/fonts/IdealSans-SemiboldItalic-Pro.otf') format('opentype');
    font-weight: 600;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'Ideal Sans';
    src: url('/fonts/IdealSans-Bold-Pro.otf') format('opentype');
    font-weight: 700;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Ideal Sans';
    src: url('/fonts/IdealSans-BoldItalic-Pro.otf') format('opentype');
    font-weight: 700;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'Ideal Sans';
    src: url('/fonts/IdealSans-Black-Pro.otf') format('opentype');
    font-weight: 900;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Ideal Sans';
    src: url('/fonts/IdealSans-BlackItalic-Pro.otf') format('opentype');
    font-weight: 900;
    font-style: italic;
    font-display: swap;
  }
`

// Inject font faces
if (typeof document !== 'undefined') {
  const style = document.createElement('style')
  style.innerHTML = fontFaces
  document.head.appendChild(style)
}
